// extracted by mini-css-extract-plugin
export default {"container":"OC_container__KcZnN","heading":"OC_heading__Gawqy","para":"OC_para__VHJKB"};